/**
 * Hybrid Page View - Router
 *
 * Routes to legacy or v2 layout based on useLayoutV2 prop.
 * This is the entry point for the hybrid page view.
 */

import React, { forwardRef } from 'react';
import { HybridPageLegacy } from './legacy';
import { HybridPageV2 } from './v2';
import type { HybridPageLegacyProps, HybridPageLegacyViewMethods } from './legacy';
import type { HybridPageV2ViewMethods } from './v2/hybrid-page-v2-view';

// Re-export types for backwards compatibility
export type { Pagination, AreaInsightsData } from './legacy';
export type HybridPageViewMethods = HybridPageLegacyViewMethods;

// Use legacy props as the main props type for backwards compatibility
export type HybridPageViewProps = HybridPageLegacyProps;

const HybridPageView = forwardRef<HybridPageViewMethods, HybridPageViewProps>(
  function HybridPageView(props, ref) {
    const { useLayoutV2 } = props;

    if (useLayoutV2) {
      return <HybridPageV2 ref={ref as React.ForwardedRef<HybridPageV2ViewMethods>} {...props} />;
    }

    return <HybridPageLegacy ref={ref} {...props} />;
  }
);

export default HybridPageView;
